import * as React from "react";
import * as ReactDOM from "react-dom";
import MainPageComponent from "./components/MainPageComponent";
import GameComponent from "./components/Game";
import { StoreProvider } from "easy-peasy";
import { initializeStore } from "./store";
import { ValentineModeToggle } from "./components/ValentineModeToggle";
// import { GlobeVisualization } from "./components/Visualizations/GlobeThree";
import { GlobeD3 } from "./components/Visualizations/GlobeD3";
import { GlobeThree } from "./components/Visualizations/GlobeThree";

const store = initializeStore();

function App() {
  const [renderOption, setRenderOption] = React.useState("three");

  return (
    <>
      <MainPageComponent />
      <GameComponent />
      <select
        style={{
          position: "absolute",
          right: 20,
          top: 60,
          zIndex: 2,
        }}
        value={renderOption}
        onChange={(e) => setRenderOption(e.target.value)}
      >
        <option value="d3">Render with d3</option>
        <option value="three">Render with three.js</option>
      </select>
      {
        {
          d3: <GlobeD3 />,
          three: <GlobeThree />,
        }[renderOption]
      }
      <ValentineModeToggle />
    </>
  );
}

ReactDOM.render(
  <StoreProvider store={store}>
    <App />
  </StoreProvider>,
  document.getElementById("app")
);
